// Render nothing in native for now.
export default function ContentOnlySettingsMenu() {
	return null;
}
